// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
// Partials
import { PartialsModule } from '../partials/partials.module';
// Pages
import { CoreModule } from '../../core/core.module';
import { FeedbackComponent } from './feedback/feedback.component';
import { PucaModule } from './puca/puca.module';
// import { NotificationsListComponent } from './notifications-list/notifications-list.component';
// import { ApplicationSchedulingComponent } from './application-scheduling/application-scheduling.component';
// import { InternationalPhoneNumberModule } from 'ngx-international-phone-number';
// import { AuthModule } from './auth/auth.module';

@NgModule({
	declarations: [],
	exports: [],
	imports: [
		CommonModule,
		HttpClientModule,
		FormsModule,
		// InternationalPhoneNumberModule,
		CoreModule,
		PartialsModule,
		// AuthModule,
	],
	providers: [],
})
export class PagesModule {
}
